import env from 'env'

import { Api } from '.'

import { fixCDNBaseUrl } from '../../utils'

import type { BaseSDK } from '../../sdk'

export class StashApi extends Api {
  origin = env.STASH_API_BASE
  version = 'v1'

  async fetchStash() {
    const noStash: StashInfoResponse = { userId: null, itemsCount: 0 }
    try {
      const response = await this.fetch('/stash')
      if (response.ok) return await response.json() as StashInfoResponse
      return noStash
    } catch {
      return noStash
    }
  }

  async fetchStashItem(id: string | number) {
    try {
      if (id == null) return null

      const response = await this.fetch(`/stash/items/releases/${+id}`)

      if (response.ok) return await response.json() as StashReleaseItem

      else return null
    } catch {
      return null
    }
  }

  async fetchStreamLink(id: string | number, releaseId: string | number, sdk: BaseSDK) {
    try {
      if (id == null) return null

      const query = {
        platformId: 1,
        releaseId,
        deviceId: sdk.uuid,
      }

      const response = await this.fetch(`/stash/tracks/${+id}/streamlink`, 'GET', query)

      if (response.ok) {
        const { streamLink } = await response.json()

        if (streamLink && typeof streamLink === 'string') return { id, quality: 0, date: new Date, data: fixCDNBaseUrl(streamLink) }
      }

      return null
    } catch {
      return null
    }
  }
}

export type StashInfoResponse = {
  userId: Nullable<string>
  itemsCount: number
}

export type StashReleaseItem = {
  id: string
  orderId: string
  addedAt: string
  status: string | 'available' | 'expired'
  accessExpiresAt: Nullable<string>
  isStreamOnly: boolean
  product: {
    id: string
    format: string
    type: string
    title: string
    contentType: string
    songTitle: Nullable<string>
    trackId: Nullable<string>
    isLiveEvent: boolean
    liveEventStartsAt: Nullable<string>
    liveEventEndsAt: Nullable<string>
    liveEventTimeZone: Nullable<string>
    release: {
      id: string
      status: string
      type: string
      title: string
      performanceDate: Nullable<string>
      albumTitle: Nullable<string>
      albumAbbreviation: Nullable<string>
      albumReleaseDate: Nullable<string>
      coverImage: Nullable<string>
      image: Nullable<{ url: Nullable<string> }>
      venue: Nullable<{
        id: string
        title: string
        name: string
        city: string
        state: string
        country: string
      }>
      artist: {
        id: string
        name: string
        abbreviation: string
      }
      isInSubscriptionCatalog: boolean
    }
  }
}
